import { countries, type TCountryCode } from 'countries-list';

export function getCountryName(countryCode: string): string {
  try {
    return countries[countryCode as TCountryCode].name;
  } catch {
    console.error('Invalid country code:', countryCode);
    return countryCode;
  }
}
